import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../hooks/useLocalizedPath';
import { SEOMeta } from '../components/SEOMeta';
import {
  RepriseHero,
  RepriseValueProps,
  RepriseProcess,
  RepriseProof,
} from '../components/sections/reprise';
import { Section, Container, Button } from '../components/ui';
import { ArrowRight } from 'lucide-react';
import { RelatedPages } from '../components/RelatedPages';
import styles from './RepriseParcInformatique.module.css';

export function RepriseParcInformatique() {
  const { t } = useTranslation('reprise');
  const { lp } = useLocalizedPath();

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />

      <div className={styles.aboveFold}>
        <div className={styles.aboveFoldBg} />
        <RepriseHero />
        <div className={styles.scrollIndicator} aria-hidden="true">
          <div className={styles.chevron} />
          <div className={styles.chevron} />
          <div className={styles.chevron} />
        </div>
      </div>

      <RepriseValueProps />
      <RepriseProcess />
      <RepriseProof />

      <Section variant="light">
        <Container>
          <div className={styles.ctaWrapper}>
            <div className={styles.ctaCard}>
              <h2 className={styles.ctaTitle}>{t('cta.title')}</h2>
              <p className={styles.ctaDesc}>{t('cta.desc')}</p>
              <div className={styles.ctaActions}>
                <Button href={lp('/contact')} data-attr="cta-contact">{t('cta.primary')}</Button>
                <a href="mailto:partners@qbp.solutions" className={styles.ctaLink} data-attr="contact-email">
                  {t('cta.secondary')}
                  <ArrowRight size={16} />
                </a>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      <RelatedPages currentFrPath="/reprise-parc-informatique" />
    </>
  );
}
